import React, { FC } from 'react';
import { observer } from 'mobx-react-lite';
import type { IDistribution } from '../../../model/distributions/Distribution';
import { formatISODateStringAsLocal } from '../common/Utils';
import { useDistributionsResult } from './useDistributions';
import { CustomSpinner } from '@yakoffice/custom-spinner';
import { YoPublisherTable, YoTableClassNames } from '../../components/yo-publisher-table/YoPublisherTable';
import JiraIssueLinks from './JiraIssueLinks';
import { useGetDistributionExperimentsLink, useGetDistributionLink } from '../../routes';
import { useNavigate } from 'react-router';
import { Badge } from 'react-bootstrap';
import { AbbreviatedString } from '../../components/abbreviated-string/AbbreviatedString';
import { StatusLabel } from '../../components/tables/status-label/StatusLabel';
import Button from 'react-bootstrap/Button';

interface PropsType {
    distributionsResult: useDistributionsResult,
    checkedDistributions: IDistribution[],
    handleDistributionCheckedToggle: (distribution: IDistribution) => void
}

export const DistributionsTable: FC<PropsType> = observer((props) => {

    const navigate = useNavigate();
    const getDistributionLink = useGetDistributionLink();
    const getDistributionExperimentsLink = useGetDistributionExperimentsLink();

    return (
        <div className="mdcDataTableContainer">
            <YoPublisherTable className={YoTableClassNames.MinWidthContainer}>
                <thead>
                <tr>
                    <th className="td-checkbox" />
                    <th className="td-status">Status</th>
                    <th>ID</th>
                    <th>Version</th>
                    <th>Updated</th>
                    <th className="d-none d-md-table-cell">Comment</th>
                    <th className="d-none d-md-table-cell">Jiras</th>
                    <th className="d-none d-md-table-cell">Author</th>
                    <th className="td-experiments">Experiments</th>
                </tr>
                </thead>
                <tbody>
                {!props.distributionsResult.isLoaded &&
                    <tr>
                        <td colSpan={42}><CustomSpinner spinnerText="Loading Distributions..." /></td>
                    </tr>
                }
                {props.distributionsResult.isLoaded && props.distributionsResult.distributions && props.distributionsResult.distributions.length === 0 &&
                    <tr>
                        <td colSpan={42} className="text-center">No Distributions found for this Game Version and
                            Environment with
                            current filters
                        </td>
                    </tr>
                }
                {props.distributionsResult.isLoaded && props.distributionsResult.distributions && props.distributionsResult.distributions.length > 0 &&
                    props.distributionsResult.distributions.map(d =>
                        <tr key={d.id}>
                            <td className="td-checkbox">
                                <input type="checkbox" className="checkbox" id={`checkbox${d.id}`}
                                       onClick={() => props.handleDistributionCheckedToggle(d)}
                                       disabled={props.checkedDistributions.length >= 2 && !props.checkedDistributions.includes(d)} />
                            </td>
                            <td onClick={() => navigate(getDistributionLink({ distributionId: d.id }))}
                                className="td-status text-center cursor-pointer">
                                {d.succeeded && <StatusLabel status={'succeeded'} />}
                                {!d.succeeded && <StatusLabel status={'failed'} />}
                                {d.deleted && <StatusLabel status={'deleted'} />}
                            </td>
                            <td onClick={() => navigate(getDistributionLink({ distributionId: d.id }))}
                                className="cursor-pointer">{d.id}</td>
                            <td onClick={() => navigate(getDistributionLink({ distributionId: d.id }))}
                                className="cursor-pointer">{d.distributionVersion}</td>
                            <td onClick={() => navigate(getDistributionLink({ distributionId: d.id }))}
                                className="cursor-pointer">{formatISODateStringAsLocal(d.updatedAt)}</td>
                            <td onClick={() => navigate(getDistributionLink({ distributionId: d.id }))}
                                className="d-none d-md-table-cell max-width cursor-pointer">{d.comment}</td>
                            <td onClick={() => navigate(getDistributionLink({ distributionId: d.id }))}
                                className="d-none d-md-table-cell max-width cursor-pointer"><JiraIssueLinks
                                className="d-inline text-info"
                                delimiter=", "
                                jiraIssueIds={d.jiraIssueIds} />
                            </td>
                            <td onClick={() => navigate(getDistributionLink({ distributionId: d.id }))}
                                className="d-none d-md-table-cell cursor-pointer">{d.lastAuthor}</td>
                            <td className={`text-center td-experiments`}>
                                <Button className="" disabled={d.experimentCount === 0}
                                        onClick={() => navigate(getDistributionExperimentsLink({ distributionId: d.id }))}>
                                    {d.experimentCount}</Button>
                            </td>
                        </tr>)
                }
                </tbody>
            </YoPublisherTable>
        </div>
    );
});
